import { useQuery } from '@ts-core/lib/apollo';

import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';
import { ProfessorActivity } from '../types/index';

import { getActivitiesQuery, GetActivitiesQueryResult, GetActivitiesQueryVariables } from '../graphql/queries/getActivitiesQuery';

export interface ActivitiesHookInput {
  courseId: string;
}

export interface ActivitiesHookPayload {
  activities?: ProfessorActivity[];
  loading: boolean;
}

export default function useActivities({ courseId }: ActivitiesHookInput): ActivitiesHookPayload {
  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading } = useQuery<GetActivitiesQueryResult, GetActivitiesQueryVariables>(getActivitiesQuery, {
    variables: { courseId },
    onError: showErrorNotification,
    fetchPolicy: 'cache-and-network',
  });

  return {
    activities: data?.activities,
    loading,
  };
}
